import { Component, OnInit } from '@angular/core';
import { UnsavedSceneService } from '../../services/unsaved-scene.service';
import { OutcomesService } from '../../services/outcomes.service';
import { Outcome } from 'src/app/models/outcomes/Outcome';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ApiSceneOutcomeRelationService } from 'src/app/api-services/scene-outcome-relation.api.service';
import { SceneOutcomeRelation } from 'src/app/models/SceneOutcomeRelation';
import { ModalController } from '@ionic/angular';
import { ViewOutcomeModalPage } from '../view-outcome-modal/view-outcome-modal.page'
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';

@Component({
  selector: 'app-add-outcome-to-scene-modal',
  templateUrl: './add-outcome-to-scene-modal.page.html',
  styleUrls: ['./add-outcome-to-scene-modal.page.scss'],
})
export class AddOutcomeToSceneModalPage implements OnInit {

  public sceneId: number;
  public isModalOpen: boolean = false;

  constructor(
    public unsavedSceneService: UnsavedSceneService,
    public modalController: ModalController,
    public outcomeService: OutcomesService,
    public sceneOutcomeRelationApiService: ApiSceneOutcomeRelationService,
    public unfocusService: UnfocusElementService
  ) { }

  ngOnInit() {

  }


  filterOutcomes(data: any) {
    return data["active"] == true;
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async viewOutcome(outcome) {

    if(this.isModalOpen === true) return;
    this.isModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewOutcomeModalPage,
      id: 'outcome-view-modal',
      componentProps: {
        "Learning Objective": outcome
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    return await modal.present();
  }

  addNewOutcome(event) {
    this.unfocusService.unfocus(event);
    this.outcomeService.openAddOutcomeModal(null, false);
  }
}
